import {
  CheckCircle2,
  ClipboardList,
  FileText,
  LayoutTemplate,
  PlayCircle,
  type LucideIcon,
} from "lucide-react";

const ICONS: Record<string, LucideIcon> = {
  CheckCircle2,
  ClipboardList,
  LayoutTemplate,
  PlayCircle,
  FileText,
};

export const RESOURCE_ICON_OPTIONS = Object.keys(ICONS);

export function resolveResourceIcon(name?: string | null): LucideIcon {
  if (!name) return FileText;
  return ICONS[name] ?? FileText;
}
